import register from '@kpsys/angularjs-register';
import {MailerDataService} from 'shared/mailer/mailer-data.service';
import {MailerService} from 'shared/mailer/mailer.service';


/**
 * @ngdoc module
 * @name portaro.shared.mailer
 * @module portaro.shared.mailer
 */

export default register('portaro.shared.mailer')
    .service(MailerDataService.serviceName, MailerDataService)
    .service(MailerService.serviceName, MailerService)
    .name()